import { httpClient } from '../commons/httpClient'
import { SignupValues } from './common'

const signup = (signup: SignupValues): Promise<any> => {
  return httpClient.post('/Account/Create', signup)
}

export default signup
